import { MenuSeparator } from './MenuSeparator';

export default MenuSeparator;
